import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const CategoryOutgoing = () => {
  return (
    <SettingsMetaData propertyName={"Category_Outgoing"} viewPropertyName={"Category"} />
  );
};
export default CategoryOutgoing;